// extracted by mini-css-extract-plugin
export default {"root":"radio_root__LjSmK","checked":"radio_checked__8zttf","disabled":"radio_disabled__658GH"};